import { useState, useCallback, useEffect } from 'react';
import { useResponsive } from '../hooks/useResponsive';
import { useAppState } from '../context/AppStateContext';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/layout/Sidebar';
import BottomNav from '../components/layout/BottomNav';
import GlobalHeader from '../components/layout/GlobalHeader';
import GroupsTab from '../components/tabs/GroupsTab';
import NotificationsPanel from '../components/shared/NotificationsPanel';
import GuestPromptDrawer from '../components/shared/GuestPromptDrawer';

export default function GroupsPage() {
  const { isDesktop } = useResponsive();
  const { showNotifications, setShowNotifications, showGroupOverviewDrawer } = useAppState();
  const { isGuestMode, setShowGuestPrompt } = useAuth();

  // Show guest prompt when guest tries to access groups
  useEffect(() => {
    if (isGuestMode) {
      setShowGuestPrompt(true);
    }
  }, [isGuestMode, setShowGuestPrompt]);
  const [contentLoading, setContentLoading] = useState(true);

  // Callback to receive loading state from GroupsTab
  const handleLoadingChange = useCallback((loading) => {
    setContentLoading(loading);
  }, []);

  // Loading screen with pulsing logo (shown while content loads in background)
  const LoadingScreen = () => (
    <div className="fixed inset-0 z-50 flex flex-col bg-white">
      {/* Header - matches global header (logo icon only) */}
      <header className="bg-white px-4 pb-3 pt-[calc(0.75rem+env(safe-area-inset-top))] flex items-center border-b border-gray-100">
        <img src="/logo/bonndleLogoIcon_Indigo.svg" alt="Bonndle" className="h-9 w-9" />
      </header>
      {/* Centered pulsing logo */}
      <div className="flex-1 flex items-center justify-center">
        <img
          src="/logo/bonndleLogoIcon_Indigo.svg"
          alt="Bonndle"
          className="w-16 h-16 animate-pulse"
          style={{ animationDuration: '1.5s' }}
        />
      </div>
    </div>
  );

  if (isDesktop) {
    return (
      <>
        {contentLoading && <LoadingScreen />}
        <div className="flex h-screen h-dvh bg-gray-50">
          <Sidebar />
          <main className="flex-1 flex flex-col overflow-hidden ml-64">
            <GlobalHeader />
            <div className="flex-1 overflow-y-auto scrollbar-hide">
              <GroupsTab onLoadingChange={handleLoadingChange} />
            </div>
          </main>

          {showNotifications && (
            <NotificationsPanel onClose={() => setShowNotifications(false)} />
          )}

          <GuestPromptDrawer />
        </div>
      </>
    );
  }

  return (
    <>
      {contentLoading && <LoadingScreen />}
      <div className="flex flex-col h-screen h-dvh bg-gray-50">
        <main className="flex-1 flex flex-col overflow-hidden pb-nav">
          <GroupsTab onLoadingChange={handleLoadingChange} />
        </main>
        {/* Hide BottomNav when GroupOverviewDrawer is open - JOIN GROUP button takes its place */}
        {!showGroupOverviewDrawer && <BottomNav />}

        {showNotifications && (
          <NotificationsPanel onClose={() => setShowNotifications(false)} />
        )}

        <GuestPromptDrawer />
      </div>
    </>
  );
}
